import SectionWithSlider from "@components/global/SectionWithSlider"
import { useScrollAnim } from "src/hooks/hooks"
import { convertHtmlToReact, formatDate, imgUrl } from "src/mixins"

function CareerLandingLifeAt({ data, locale }) {
  return (
    <SectionWithSlider
      sectionName="transparent sc-career-life-at"
      cardType="boxless"
      data={data?.list?.map((item) => ({
        title: item[`title_${locale}`],
        text: convertHtmlToReact(item[`content_${locale}`]),
        img: imgUrl(item?.thumb_image),
      }))}
      title={data && data[`title_${locale}`]}
      text={convertHtmlToReact(data[`description_${locale}`])}
      slidesPerViewMobile={1.6}
      slidesPerViewDesktop={2.1}
      hasArrow
      navTheme="light"
    />
  )
}

export default CareerLandingLifeAt
